import React from "react";
import styled from "styled-components";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { RadioDropdownItem } from "@sonder/ui/source/styled/fragments/RadioDropdownItem";
import { setFilters } from "schedule/actions";
import { useStore } from "schedule/store";
import { TaskScheduleStatusEnum } from "typings/globalGQLTypes";

const StyledDropdownContent = styled(DropdownContent)`
  width: 15rem;
`;

export const ScheduleStatusFilters = () => {
  const {
    state: { filters },
    dispatch,
  } = useStore();

  const { scheduleStatus } = filters;

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Show {scheduleStatus}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen, closePortal }) =>
        isPortalOpen && (
          <StyledDropdownContent>
            <div>
              {[
                TaskScheduleStatusEnum.all,
                TaskScheduleStatusEnum.scheduled,
                TaskScheduleStatusEnum.unscheduled,
              ].map(taskScheduleStatus => {
                return (
                  <RadioDropdownItem
                    checked={taskScheduleStatus === scheduleStatus}
                    key={taskScheduleStatus}
                    onClick={() => {
                      dispatch(
                        setFilters({
                          scheduleStatus: taskScheduleStatus,
                        }),
                      );
                      closePortal();
                    }}
                  >
                    <div>Show {taskScheduleStatus}</div>
                  </RadioDropdownItem>
                );
              })}
            </div>
          </StyledDropdownContent>
        )
      }
    </Dropdown>
  );
};
